import React from 'react';
import styled from "@emotion/styled";

const TableCell = styled.span``;
export default (props) => (<TableCell>{props.children}</TableCell>)
